import React, { ComponentProps, forwardRef } from 'react';
import { OutlinedInput as OutlinedInputMUI } from '@mui/material';

import { SHAPE_CIRCULAR, SHAPE_SQUARE } from '@/mui/constants';

import type { ShapeProp } from '@/mui/types';

type Props = ComponentProps<typeof OutlinedInputMUI> & {
  shape?: ShapeProp;
};

const OutlinedInput = forwardRef<HTMLDivElement, Props>(({ shape, sx, ...rest }, ref) => (
  <OutlinedInputMUI
    ref={ref}
    {...rest}
    sx={{
      ...(shape === SHAPE_SQUARE && {
        borderRadius: 0,
      }),
      ...(shape === SHAPE_CIRCULAR && {
        borderRadius: (theme) => theme.shape.borderRadiusCircular,
      }),
      ...sx,
    }}
  />
));

OutlinedInput.displayName = 'OutlinedInput';

export default OutlinedInput;
